import { seoContent } from '@/mocks/seoContent';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[40%]">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Thoughtful%20young%20person%20sitting%20at%20modern%20minimalist%20desk%20with%20laptop%20in%20bright%20airy%20room%20natural%20window%20light%20illuminating%20scene%20warm%20cream%20walls%20contemporary%20casual%20style%20genuine%20relaxed%20expression%20editorial%20lifestyle%20portrait%20photography%20clean%20composition%20with%20potted%20plant%20in%20background&width=800&height=900&seq=testimonial-img-v3&orientation=portrait"
                alt="OOPBuy Spreadsheet user experience"
                title="Happy OOPBuy Spreadsheet User"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-[60%]">
            <span className="inline-block text-foreground-400 text-xs tracking-widest uppercase font-medium mb-4">
              {seoContent.testimonialLabel}
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              {seoContent.testimonialTitle}
            </h2>
            <div className="mt-8">
              <i className="ri-double-quotes-l text-3xl text-accent-400"></i>
              <p className="mt-3 text-foreground-700 text-base md:text-lg leading-relaxed max-w-xl">
                {seoContent.testimonialText}
              </p>
            </div>
            <div className="mt-6 flex items-center gap-2">
              <span className="w-8 h-0.5 bg-accent-500"></span>
              <span className="text-foreground-950 font-semibold text-sm">
                {seoContent.testimonialAuthor}
              </span>
            </div>
            <div className="mt-8 flex items-center gap-3">
              <button className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-400 hover:text-foreground-600 hover:border-foreground-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center text-background-50 cursor-pointer">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}